import { Navigate } from "react-router-dom";

export default function AdminRoute({ children }) {
    // On vérifie simplement si l'ID de l'utilisateur est présent
    // Cela signifie qu'il a réussi l'étape du login.php
    const isAuthenticated = localStorage.getItem("userId") !== null;

    return isAuthenticated ? children : <Navigate to="/login" />;
}